import React from 'react';
import { Formik, Form } from 'formik';
import TextField from 'shared/components/text-field/TextField';
import { connect } from 'react-redux';
import Title from 'shared/components/title/Title';
import { createNutritionPlan } from 'features/nutrition/ducks/nutritionActions';
import { checkUniqueness } from 'api/helpers/checkUniqueness';
import { NUTRITIONS } from 'utils/constants/collectionNames';
import {
  PLAN_NAME_MUST_BE_UNIQUE,
  REQUIRED_ERROR_MSG
} from 'utils/constants/errors';
import Loader from 'features/Loader/Loader';

class CreatePlanForm extends React.Component {
  render() {
    const { history, createNutritionPlan } = this.props;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          name: ''
        }}
        onSubmit={values => {
          createNutritionPlan(values.name, history);
        }}
        validate={values => {
          const errors = {};
          if (values.name)
            return checkUniqueness(values.name, NUTRITIONS, 'name')
              .then(ans => {
                if (!ans) errors.name = PLAN_NAME_MUST_BE_UNIQUE;
                return errors;
              })
              .catch(err => console.log(err));

          return { name: REQUIRED_ERROR_MSG };
        }}
      >
        {formik => (
          <Form>
            {formik.isSubmitting ? (
              <Loader />
            ) : (
              <div className="rename-plan-form">
                <Title
                  pageTitle="Create Plan"
                  buttonText="Create"
                  linkText="Cancel"
                  cancelLink="/nutrition"
                  isSubmitting={formik.isValidating || formik.isSubmitting}
                />
                <div className="form-content">
                  <TextField
                    type="text"
                    name="name"
                    label="Plan Name"
                    placeholder="Body Fat Loss Plan"
                    maxLength={500}
                  />
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createNutritionPlan: (name, history) =>
      dispatch(createNutritionPlan(name, history))
  };
}

export default connect(null, mapDispatchToProps)(CreatePlanForm);
